import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getTasksByTenantId = createWrappedAsyncThunk(
  "tasks/getTasksByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get("task", {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  },
);

export const addEditTask = createWrappedAsyncThunk(
  "tasks/addEditTask",
  async (payload) => {
    return await httpClient.post("task", payload);
  },
);

export const addEditColumn = createWrappedAsyncThunk(
  "tasks/addEditColumn",
  async (payload) => {
    return await httpClient.post("column", payload);
  },
);

export const getCommentsByTaskId = createWrappedAsyncThunk(
  "tasks/getCommentsByTaskId",
  async ({ task_id }) => {
    const { data } = await httpClient.get("comment", {
      params: {
        task_id,
      },
    });
    return { task_id, data };
  },
);

export const addEditComment = createWrappedAsyncThunk(
  "tasks/addEditComment",
  async (payload) => {
    return await httpClient.post("comment", payload);
  },
);

export const updateCommentReaction = createWrappedAsyncThunk(
  "tasks/updateCommentReaction",
  async (payload) => {
    return await httpClient.post("comment", payload);
  },
);

export const getTaskAttachmentsByTaskId = createWrappedAsyncThunk(
  "tasks/getTaskAttachmentsByTaskId",
  async ({ task_id }) => {
    const { data } = await httpClient.get("task/attachments", {
      params: {
        task_id,
      },
    });
    return { task_id, data };
  },
);

export const addTaskAttachment = createWrappedAsyncThunk(
  "tasks/addTaskAttachment",
  async (payload) => {
    return await httpClient.post("task/attachment", payload);
  },
);

export const updateFileKey = createWrappedAsyncThunk(
  "tasks/updateFileKey",
  async ({ task_attachment_id }) => {
    return await httpClient.post(`update-file-key`, {
      task_attachment_id,
    });
  },
);

export const getTaskActivitiesByTaskId = createWrappedAsyncThunk(
  "tasks/getTaskActivitiesByTaskId",
  async ({ task_id, offset = 0 }) => {
    return await httpClient.get("task/activities", {
      params: {
        task_id,
        offset,
      },
    });
  },
);

export const getSavedCases = createWrappedAsyncThunk(
  "tasks/getSavedCases",
  async ({ tenant_id }) => {
    return await httpClient.get("case-form", {
      params: {
        tenant_id,
        type: "taskCases",
      },
    });
  },
);
